import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faImage, faLocationDot, faStore } from '@fortawesome/free-solid-svg-icons';

import './CrearTienda.css';

const initialForm = {
  nombre: '',
  provincia: '',
  ciudad: '',
  codigo_postal: '',
  direccion: '',
  telefono: '',
  mail: '',
  horario: '',
  descripcion: '',
  logo: '',
};

const CrearTienda = () => {
  const [formData, setFormData] = useState(initialForm);
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');
  const [tiendaCreada, setTiendaCreada] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((actual) => ({
      ...actual,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensaje('');
    setError('');
    setTiendaCreada(null);

    try {
      setLoading(true);
      const response = await fetch('/api/crear_tienda', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          Nombre: formData.nombre,
          vencimiento: '2025-12-31',
          habilitada: 1,
          tiendadestacada: 0,
          ...formData,
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (response.status === 401) {
        window.location.href = '/login';
        return;
      }

      if (!response.ok) {
        throw new Error(data.error || 'Error al crear la tienda.');
      }

      setMensaje('Tienda creada correctamente.');
      setTiendaCreada(data.Idtienda);
      setFormData(initialForm);
    } catch (err) {
      console.error('Error:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="crear-tienda">
      <div className="crear-tienda-heading">
        <p>Tu espacio de venta</p>
        <h2>Crear tienda</h2>
      </div>

      <form className="crear-tienda-form" onSubmit={handleSubmit}>
        <fieldset>
          <legend>
            <FontAwesomeIcon icon={faStore} />
            Datos principales
          </legend>
          <div className="crear-tienda-grid">
            <label>
              Nombre de la tienda
              <input type="text" name="nombre" value={formData.nombre} onChange={handleChange} required />
            </label>
            <label>
              Correo comercial
              <input type="email" name="mail" value={formData.mail} onChange={handleChange} required />
            </label>
            <label>
              Teléfono
              <input type="tel" name="telefono" value={formData.telefono} onChange={handleChange} required />
            </label>
            <label>
              Horario de atención
              <input type="text" name="horario" value={formData.horario} onChange={handleChange} placeholder="Lun a Vie 10 a 18" required />
            </label>
          </div>
        </fieldset>

        <fieldset>
          <legend>
            <FontAwesomeIcon icon={faLocationDot} />
            Ubicación
          </legend>
          <div className="crear-tienda-grid">
            <label>
              Provincia
              <input type="text" name="provincia" value={formData.provincia} onChange={handleChange} required />
            </label>
            <label>
              Ciudad
              <input type="text" name="ciudad" value={formData.ciudad} onChange={handleChange} required />
            </label>
            <label>
              Código postal
              <input type="text" name="codigo_postal" value={formData.codigo_postal} onChange={handleChange} />
            </label>
            <label className="crear-tienda-wide">
              Dirección
              <input type="text" name="direccion" value={formData.direccion} onChange={handleChange} required />
            </label>
          </div>
        </fieldset>

        <fieldset>
          <legend>
            <FontAwesomeIcon icon={faImage} />
            Presentación
          </legend>
          <div className="crear-tienda-grid">
            <label className="crear-tienda-wide">
              Logo o imagen de portada
              <input type="url" name="logo" value={formData.logo} onChange={handleChange} placeholder="https://..." required />
            </label>
            <label className="crear-tienda-wide">
              Descripción
              <textarea name="descripcion" value={formData.descripcion} onChange={handleChange} rows="4" required />
            </label>
          </div>
        </fieldset>

        {mensaje && (
          <div className="crear-tienda-message success">
            {mensaje}
            {tiendaCreada && (
              <Link to={`/tienda/${tiendaCreada}`}>
                Ver tienda <FontAwesomeIcon icon={faArrowRight} />
              </Link>
            )}
          </div>
        )}
        {error && <p className="crear-tienda-message error">{error}</p>}

        <div className="crear-tienda-actions">
          <Link to="/cuenta#Tiendas">Volver a mis tiendas</Link>
          <button type="submit" disabled={loading}>
            {loading ? 'Creando...' : 'Crear tienda'}
          </button>
        </div>
      </form>
    </section>
  );
};

export default CrearTienda;
